import { FetchPaginatedApiModel } from "../models/shared/CommonModels";
import { CondizioneModel } from "../models/CondizioneModel";
import { api_url } from "../utils/ApiContext";
import { getRequest } from "./apiCommon";
import { appendStringToUri } from "../utils/filtering";

const fetchAllFinalConditions = () => {
  return getRequest<FetchPaginatedApiModel<CondizioneModel[]>>(
    api_url.concat("/api/condizione/final")
  );
};

const fetchCondizioniByName = async (name: string | undefined) => {
  let uri = api_url.concat("/api/condizione");
  uri = uri.concat("?skip=0&take=", "20");

  if (name !== undefined) {
    uri = appendStringToUri("nome", name, uri);
  }
  return (await getRequest<FetchPaginatedApiModel<CondizioneModel[]>>(uri))
    .data;
};

export { fetchAllFinalConditions, fetchCondizioniByName };
